module.exports = __webpack_public_path__ + "static/img/color.2133bf19.jpg";